import script from "./SheetGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./SheetGallery.vue?vue&type=script&setup=true&lang=js"

import "./SheetGallery.vue?vue&type=style&index=0&id=3da1a95b&lang=css"

const __exports__ = script;

export default __exports__